/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Unpublished1Inputs */

const vi_cmspost_unpublished1 = /** @type {(inputs: Cmspost_Unpublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gỡ bài khỏi web.`)
};

/**

* @param {Cmspost_Unpublished1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_unpublished1 = /** @type {((inputs?: Cmspost_Unpublished1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Unpublished1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_unpublished1(inputs)
});
export { cmspost_unpublished1 as "cmsPost_unpublished" }